module.exports = __webpack_public_path__ + "media/images/admin/icons/phone-outgoing-5689cee5bfdc8ef677bcdc578f76ddb2.svg";